import PropTypes from 'prop-types'

const LayoutProgram = (props) => {
  return (
    <>
      <div className="LayoutProgram">
        <div className="LayoutProgram-inner">
          <div className="LayoutProgram-header">{props.headerContent}</div>
          <div className="LayoutProgram-main">{props.mainContent}</div>
        </div>
      </div>
    </>
  )
}

LayoutProgram.propTypes = {
  mainContent: PropTypes.any,
  headerContent: PropTypes.shape({})
}

export default LayoutProgram
